/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formcompanyname_Label2Inputs */

const ja_contact_formcompanyname_label2 = /** @type {(inputs: Contact_Formcompanyname_Label2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会社名`)
};

const en_contact_formcompanyname_label2 = /** @type {(inputs: Contact_Formcompanyname_Label2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Company Name`)
};

/**
* | output |
* | --- |
* | "Your Company Name" |
*
* @param {Contact_Formcompanyname_Label2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formcompanyname_label2 = /** @type {((inputs?: Contact_Formcompanyname_Label2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formcompanyname_Label2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formcompanyname_label2(inputs)
	return en_contact_formcompanyname_label2(inputs)
});
export { contact_formcompanyname_label2 as "contact_formCompanyName_label" }